import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { getData } from '../../../data/followup/selectors/followup';
import Summary from '../components/Summary';
import { fetchUserSession } from "../../../data/account/actions/userSession";

class SummaryContainer extends Component {
    static propTypes = {
        isFetching: PropTypes.bool,
        data: PropTypes.object
    };

    componentDidMount() {
        this.props.fetchUserSession();
    }
    render() {
        const { isFetching, data } = this.props;
        return (
            <Summary isFetching={isFetching} data={data} />
        );
    }
}

export default connect(
    state => ({
        isFetching: state.followup.followup.isFetching,
        data: getData(state.followup)
    }),
    (dispatch) => bindActionCreators({ fetchUserSession }, dispatch)
)(SummaryContainer);
